import { useTranslation } from "react-i18next";
import Input from "components/Input";
import styles from "./styles.module.scss";
import Button from "components/Button";
import { useEffect, useRef, useState } from "react";
import keysService from "api/keysService";
import { setKeys } from "utils/setKeys";
import { decryptKeys } from "utils/decryptKeys";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import NotaIcon from "assets/icons/nota.svg?react";
import { getUserId } from "utils/getUserId";
import { clearAllKeys } from "utils/clearAllKeys";

import BG from "assets/icons/loginbg.png";

const Recovery = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  // sytuacja, niezalogowanego użytkownika
  // przychodzącego z hashem z kluczem przywracania
  const { uId } = useParams();
  const { hash } = useLocation();
  const hashValue = hash?.slice(1); // strip leading #
  const recoveryKeyOverride = useRef("");
  const [recoveryKey, setRecoveryKey] = useState("");
  const userId = getUserId(auth.user);

  useEffect(() => {
    if (!!uId?.length && !!hashValue.length) {
      if (!auth.isAuthenticated) {
        localStorage.setItem(`${uId}.rk`, hashValue);
        auth.signinRedirect();
      } else {
        recoveryKeyOverride.current = hashValue;
        handleRecoveryKeys();
      }

      return;
    }

    if (auth.isAuthenticated) {
      if (userId.length) {
        const itm = localStorage.getItem(`${userId}.rk`);

        if (itm) {
          recoveryKeyOverride.current = itm;
          localStorage.removeItem(`${userId}.rk`);
          handleRecoveryKeys();
        }
      }
    }
  }, []);

  const { data: recoveryPackage, isLoading } =
    keysService.useGetRecoveryPackage(!!userId.length);

  const navigate = useNavigate();

  const [error, setError] = useState("");

  const handleRecoveryKeys = async () => {
    setError("");
    try {
      if (!recoveryPackage) {
        throw new Error("No Package");
      }

      const rk =
        recoveryKeyOverride.current.length > 0
          ? recoveryKeyOverride.current
          : recoveryKey;

      const result = await decryptKeys(recoveryPackage, rk);
      setKeys(userId, result, result.publicKey.keys[0], rk);
      navigate("/");
    } catch (e) {
      setError(t("validation.invalidRecoveryKey"));
    }
  };

  const logout = () => {
    clearAllKeys(userId);
    auth.signoutRedirect();
  };

  return (
    <div>
      <img src={BG} className={styles.bg} />
      <div className={styles.top}>
        <NotaIcon className={styles.icon} />
        <div onClick={() => logout()} className={styles.logout}>
          {t("common.backHome")}
        </div>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.modal}>
          <div className={styles.header}>
            <div className={styles.title}>{t("recovery.title")}</div>
          </div>
          <div className={styles.history}>{t("recovery.keyNotFound")}</div>
          <div className={styles.input}>
            <Input
              placeholder={t("activation.stepper.recoveryKey.title")}
              label=""
              onChange={(text) => setRecoveryKey(text)}
            />
            {!!error.length && <div className={styles.error}>{error}</div>}
            <div className={styles.btnWrapper}>
              <Button
                disabled={recoveryKey.length < 32 || isLoading}
                className={styles.btn}
                text={t("recovery.restoreKeys")}
                onClick={handleRecoveryKeys}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Recovery;
